import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative bg-white grid lg:justify-items-start justify-items-center rounded px-5 py-5" }
const _hoisted_2 = { class: "body lg:text-left text-center pt-10" }
const _hoisted_3 = { class: "text-xl font-semibold py-3" }
const _hoisted_4 = { class: "text-lg text-grayish-violet" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _renderSlot(_ctx.$slots, "icon"),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h1", _hoisted_3, [
        _renderSlot(_ctx.$slots, "title")
      ]),
      _createElementVNode("p", _hoisted_4, [
        _renderSlot(_ctx.$slots, "text-description")
      ])
    ])
  ]))
}